// Policy register CSV export (prototype "Export register").
//
// Formula-injection guard: a spreadsheet evaluates a cell that starts with =, +, -, @, tab or CR
// as a formula even when the value is quoted, so such values get a leading apostrophe first
// (which the spreadsheet shows as a text marker), and only then normal CSV quote-escaping.

const FORMULA_PREFIX = /^[=+\-@\t\r]/;

export const escapeCsvCell = (value) => {
    let s = value === null || value === undefined ? "" : String(value);
    if (FORMULA_PREFIX.test(s)) s = "'" + s;
    return '"' + s.replaceAll('"', '""') + '"';
};

// No "Reviewers" column: the register rows do not carry the reviewer set, and a header over an
// always-empty column is worse than no column.
export const POLICY_REGISTER_COLUMNS = [
    "Policy ID", "Title", "Owner", "Lifecycle", "Version", "In-force version", "Category", "Effective", "Next review",
    "Expires", "Cadence", "Date status",
];

const cadenceLabel = (months) => ({ 12: "Annual", 6: "Semiannual", 3: "Quarterly" }[months] || (months ? `${months} months` : ""));
const day = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

// Same rule as the register badge: Archived / Not published / Revision in progress / Expired /
// Not yet effective / Review overdue / Within date range.
// Computed from the LIVE row only. While a revision is open the live row is an unpublished draft
// ("Revision in progress"); the in-force snapshot's own review/expiry dates are not on the list DTO,
// so an overdue review of the in-force version is reported by the daily job (event + email), not here.
export const dateStatusOf = (p, now = new Date()) => {
    if (p.lifecycleStatus === "Archived") return "Archived";
    if (!p.publishedAt) return p.inForceVersionId ? "Revision in progress" : "Not published";
    if (p.expirationDate && new Date(p.expirationDate) <= now) return "Expired";
    if (p.effectiveDate && new Date(p.effectiveDate) > now) return "Not yet effective";
    if (p.nextReviewDate && new Date(p.nextReviewDate) < now) return "Review overdue";
    return "Within date range";
};

export const buildPolicyRegisterCsv = (policies, { titleOf, now = new Date() } = {}) => {
    const rows = policies.map(p => [
        p.id,
        titleOf ? titleOf(p) : (p.customTitle || p.fileName),
        p.ownerName || "",
        p.lifecycleStatus,
        `v${p.version}`,
        p.inForceVersionId ? "earlier version in force" : (p.publishedAt ? `v${p.version}` : ""),
        p.category || "",
        day(p.effectiveDate),
        day(p.nextReviewDate),
        day(p.expirationDate),
        cadenceLabel(p.reviewCycleMonths),
        dateStatusOf(p, now),
    ]);
    return [POLICY_REGISTER_COLUMNS, ...rows].map(r => r.map(escapeCsvCell).join(",")).join("\r\n");
};
